import axios from 'axios'
import {
  ADMINISTRATOR_ROLE,
  ADMIN_ROLE,
  COLLEGE_ROLE,
  TEACHER_ROLE,
  HOD_ROLE,
} from '../../utils/constant'
export const state = {
  currentUser: getSavedState('auth.currentUser'),
  profileData: getSavedState('auth.profile'),
  role: getRole('auth.profile'),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
  SET_PROFILE_USER(state, newValue) {
    state.profileData = newValue
    saveState('auth.profile', newValue)
  },
  SET_ROLE_USER(state, newValue) {
    state.role = newValue
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { email, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post(process.env.VUE_APP_API_BASE_URL + '/login', {
        email,
        password,
      })
      .then((response) => {
        const user = response.data
        if (
          user.user.role === ADMIN_ROLE ||
          user.user.role === COLLEGE_ROLE ||
          user.user.role === TEACHER_ROLE ||
          user.user.role === ADMINISTRATOR_ROLE ||
          user.user.role === HOD_ROLE
        ) {
          commit('SET_CURRENT_USER', user)
          commit('SET_ROLE_USER', user.user.role)
          dispatch('getUserProfile')
          return user
        } else {
          return null
        }
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
    commit('SET_PROFILE_USER', null)
    commit('SET_ROLE_USER', null)
  },

  // Get User Profile Details
  getUserProfile({ commit, state }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/profile`)
      .then((response) => {
        const user = response.data
        commit('SET_PROFILE_USER', user)
        return user
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          commit('SET_PROFILE_USER', null)
        }
        return null
      })
  },

  // Change Password
  changePassword(
    { commit, dispatch, getters },
    { oldPassword, newPassword } = {}
  ) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/profile/changePassword`, {
        oldPassword,
        newPassword,
      })
      .then((response) => {
        const message = response.data
        return message
      })
  },

  updateProfile({ commit, dispatch, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/profile`, Data)
      .then((response) => {
        const resp = response.data
        commit('SET_PROFILE_USER', resp)
        return resp
      })
  },

  // Reset Password For user
  forgotPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/forgot/admin`, { email })
      .then((response) => {
        const message = response.data
        return message
      })
  },

  resetPassword({ commit, dispatch, getters }, { Data } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/reset`, Data)
      .then((response) => {
        const message = response.data
        return message
      })
  },
  // invite user
  inviteRegister({ commit, dispatch, getters }, { userData } = {}) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/inviteregister`, { userData })
      .then((response) => {
        const message = response.data
        return message
      })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (!state.currentUser) return Promise.resolve(null)

    return getSavedState('auth.currentUser')
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function getRole(key) {
  const user = getSavedState(key)
  return user !== null ? user.role : 'user'
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentUser
    ? 'Bearer ' + state.currentUser.token
    : ''
}
